<template>
  <slot />
</template>

<script>
import createProvider from './create-provider';
import { playlist } from './prop-definitions';

export default {
  ...createProvider('refapp-video-playlist-provider', playlist),
};
</script>
